const getRandomId = () => `${Math.random()}${new Date().toISOString()}${Math.random()}`;

export default getRandomId;
